import { useState } from 'react';
import { ConditionMenu, FilterBtnWithLine } from '../style';
import { Popover } from 'react-tiny-popover';
import { AddGroupConditionIcon, AddConditionIcon } from './icons';
import React from 'react';
import { ActionIcon, rem } from '@mantine/core';
import { FaPlus } from 'react-icons/fa6';

const AddFilterBtn = ({ id, onClick, hideGroupBtn }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootId = id || 'grid-table-add-filter';

  return (
    <FilterBtnWithLine id={id || 'grid-table-add-filter-root'}>
      <div id={id ? `${rootId}-line` : 'grid-table-add-filter-line'} className="line" />
      <Popover
        isOpen={isOpen}
        onClickOutside={() => setIsOpen(false)}
        positions={['bottom', 'top', 'left', 'right']}
        padding={10}
        transitionDuration={300}
        containerStyle={{ zIndex: 1000 }}
        content={
          <ConditionMenu
            id={id ? `${rootId}-menu` : 'grid-table-add-filter-menu'}
            className="conditions"
          >
            <span
              id={id ? `${rootId}-condition` : 'grid-table-add-filter-condition'}
              onClick={() => {
                onClick('condition');
                setIsOpen(false);
              }}
            >
              <AddConditionIcon />
              Condition
            </span>
            {!hideGroupBtn && (
              <span
                id={id ? `${rootId}-group` : 'grid-table-add-filter-group'}
                onClick={() => {
                  onClick('group');
                  setIsOpen(false);
                }}
              >
                <AddGroupConditionIcon />
                Group Condition
              </span>
            )}
          </ConditionMenu>
        }
      >
        <ActionIcon
          id={id ? `${rootId}-trigger` : 'grid-table-add-filter-trigger'}
          onClick={() => setIsOpen(prev => !prev)}
          size="sm"
          variant="outline"
          w={rem(32)}
          h={rem(16)}
          bg="white"
        >
          <FaPlus color="#228BE6" fontSize="12px" />
        </ActionIcon>
      </Popover>
    </FilterBtnWithLine>
  );
};

export default AddFilterBtn;
